export default "__VITE_ASSET__Cq3ZoaYv__"